import axios from "@/api/axiosInstance";

export const deleteEmployeeProfile = async (uuid: string): Promise<void> => {
  await axios.delete(`/api/private/employee-directory/profiles/${uuid}`);
};
